module.exports = __webpack_public_path__ + "media/images/top/qa/qa_show_banner01-34000f8c599e1cb97e5c9c16ed7b7cae.jpg";